namespace $.$$ {

	export class $shm_remove_menu extends $.$shm_remove_menu {

		override showed( next?: boolean ) {
			const showed = super.showed( next )
			if( next === false ) this.remove_confirmed( false )
			return showed
		}

		menu_rows() {
			return this.remove_confirmed() ? [ this.Confirm() ] : [ this.Remove_button() ]
		}

		@ $mol_action
		remove_confirm( next?: Event ) {
			if( next !== undefined ) this.remove_confirmed( true )
			return next ?? null
		}

		@ $mol_action
		remove_accept( next?: Event ) {
			if( next === undefined ) return null
			this.remove( next )
			this.remove_confirmed( false )
			this.showed( false )
			return next
		}

		@ $mol_action
		remove_cancel( next?: Event ) {
			if( next === undefined ) return null
			this.remove_confirmed( false )
			return next
		}

	}

}
